import React from 'react';
import Header from './Header';
import Content from './Content';
import { CustomizationKey } from '../../../app/slices/customizations.slice';

export interface FinalScreenProps {
	titleCustomizationKey: CustomizationKey;
	textCustomizationKeys: Array<CustomizationKey>;
	icon: JSX.Element;
}

const FinalScreen = ({ titleCustomizationKey, icon, textCustomizationKeys }: FinalScreenProps) => {
	return (
		<div id="final-step" className="final-step" role="status" aria-live="polite">
			<div className="final-step-award" aria-hidden="true">
				{icon}
			</div>
			<Header customizationKey={titleCustomizationKey} />
			<Content contentCustomizationKeys={textCustomizationKeys} />
		</div>
	);
};

export default FinalScreen;
